// extracted by mini-css-extract-plugin
module.exports = {"svg-container":"notUnlockedDfv_svg-container__1U6tx"};